import { render, staticRenderFns } from "./_slug.vue?vue&type=template&id=0ecf2473"
import script from "./_slug.vue?vue&type=script&lang=js"
export * from "./_slug.vue?vue&type=script&lang=js"
import style0 from "./mid.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NederlandZingtCardPlaylist: require('/app/components/NederlandZingtCard/Playlist.vue').default,EoLikeButton: require('/app/node_modules/@eo/nuxt-like/lib/components/EoLikeButton.vue').default,NederlandZingtCardPlaylistItem: require('/app/components/NederlandZingtCard/PlaylistItem.vue').default,MusicGridSongs: require('/app/components/MusicGrid/Songs.vue').default,MusicGridPlaylists: require('/app/components/MusicGrid/Playlists.vue').default})
